import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export class HeaderInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (req.url.includes('apagateway')) {
      const newReq = req.clone({
        headers: req.headers.set(
          'Ocp-Apim-Subscription-Key',
          environment.apimSubscriptionKey,
        ),
      });
      return next.handle(newReq);
    } else {
      return next.handle(req);
    }
  }
}
